import config from '../config.json';

export type AppConfig = {
    environment: string;
    apiBaseUrl: string;
    notificationHubUrl: string;
    publicContainerUrl: string;
    version: string;
    gitSha: string;
    gitBranch: string;
    gitCommits: string;
    gitLastCommitAt: string;
    versionDate: string;
    secret: string;
};
export const Config = config as AppConfig;